import { OneCreateGroupDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useCreateGroupActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()

  const [createGroup, { loading }] = useMutation(OneCreateGroupDocument, {
    extractorFn: (data) => data.postsMutations.createPostsGroup,
    errorPolicy: 'all',
  })

  const createGroupHandler = async (args: { title: string; description: string }) => {
    const result = await createGroup({
      variables: {
        companyId: String(company.id),
        title: args.title.trim(),
        description: args.description.trim(),
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.group?.id) {
      const url =
        handled.data.group.frontendUrl ??
        navigation.communities.id.fullPath({ id: handled.data.group.id })

      return {
        to: url,
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: createGroupHandler,
    loading,
  }
}

export const CreateGroupAction: OneCreateAction = {
  actionResolver: useCreateGroupActionResolver,
  policies: [POSTS_POLICIES.groupCreate],
}
